export enum ERating {    
    A,
    B,
    C,
    Outsiders
}